import { render, staticRenderFns } from "./TicketNovo.vue?vue&type=template&id=fae43fa4&scoped=true&lang=pug"
import script from "./TicketNovo.vue?vue&type=script&lang=js"
export * from "./TicketNovo.vue?vue&type=script&lang=js"
import style0 from "./TicketNovo.vue?vue&type=style&index=0&id=fae43fa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fae43fa4",
  null
  
)

export default component.exports